import React, { Component } from "react"
import "./MouseOver.scss"
import _Remote from "../../api/Remote.json"
import { push } from "../Services/Analytics";

class MouseOver extends Component {
    constructor(props) {
        super();
        this.state = {
        }
    }
    onClickHandler(index) {
        this.props.showInfobox(index);
        push("Remote", _Remote[index].HTML.replace(/<\/?[^>]+(>|$)/g, ""));
        /*
        push("Remote", _Remote[index].HTML.replace(/<\/?[^>]+(>|$)/g, ""));
        */
    }
    doMouseOvers() {
        return _Remote.map((item, index) =>
            <div className={`mouseover ${item.className}`} key={index} onMouseOver={() => this.onClickHandler(index)} onClick={() => {  this.onClickHandler(index) }}>
                <div className={`pulse ${item.className}`}></div>
            </div>
        )
    }
    render() {
        return (
            <div className="mouseovers">
                {this.doMouseOvers()}
            </div>
        )
    }
}

export default MouseOver;


// WEBPACK FOOTER //
// ./src/Components/Remote/MouseOver.jsx